const KG_TO_LB = 2.20;

/**
 * Convert kilograms to pounds (US)
 * @param {number} kg - Valid kilogram value
 * @returns {number} Value in pounds (rounded to whole number)
 */
export const convertKgToPound = (kg) => {
  if (kg == null || Number.isNaN(kg) || kg <= 0) return 0;
  return Math.round(kg * KG_TO_LB);
};

/**
 * Convert pounds (US) to kilograms
 * Used for imperial input conversion before sending to backend
 * @param {number} lb - Valid pound value
 * @param {Object} options - Conversion options
 * @param {boolean} options.round - Round result (default: true)
 * @returns {number} Value in kilograms
 */
export const convertPoundToKg = (lb, { round = true } = {}) => {
  if (lb == null || Number.isNaN(lb) || lb <= 0) return 0;
  const kg = lb / KG_TO_LB;
  return round ? Math.round(kg) : kg;
};

/**
 * Get weight unit label based on display units setting
 * @param {string} displayUnits - 'imperial' or 'metric'
 * @returns {string} Unit label for display ('lb' or 'kg')
 */
export const getWeightUnitLabel = (displayUnits) => {
  return displayUnits === "imperial" ? "lb" : "kg";
};
